<template>
	<div class="meun">
		<el-breadcrumb separator="/" class="crumbs">
<!--		  <el-breadcrumb-item :to="{ path: '/Menu' }">产品列表 ( {{ form.val }} )</el-breadcrumb-item>-->
		  <el-breadcrumb-item >终端列表</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="header">
			<el-button type="primary" size="small" @click="editproduct()">添加</el-button>
			<el-button type="primary" size="small" @click="dialogVisible1()">删除批量</el-button>
      <el-button type="primary" size="small" @click="copyTerminal()" style="margin-left: 10px;">复制终端</el-button>
      <el-button type="primary" size="small" @click="copyAll()" style="margin-left: 10px;">复制所有终端</el-button>
      <el-input
        class="search"
        size="small"
        placeholder="名称搜索"
        icon="el-icon-eleme"
        v-model="form.querySertitleName"
        @keyup.enter.native="queryterminal" :on-icon-click="queryterminal"
        style="margin-left: 10px;"
      ></el-input>
      <el-form :model="form" style="display: inline-block;">
        <el-form-item size="small">
          <el-select v-model="form.type" placeholder="请选择类型" style="width: 200px;margin-left: 10px" clearable>
            <el-option
              v-for="item in tableData"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <el-button type="primary" size="small"  @click="queryterminal()" style="margin-left: 10px;">搜索</el-button>
			<el-dialog
			  :visible.sync="dialogVisible"
			  width="30%"
			  :close-on-click-modal="false"
			 >
			  <span v-if = 'form.ids == 0'>请选择数据</span>
			  <p style="margin: 0px;height: 40px; line-height: 44px;" v-if = "form.ids != 0">
				  <i class="el-icon-delete-solid" style="font-size: 40px; color:#409EFF;float: left;"></i>
				  <span style="float: left;">确定删除吗？</span>
			  </p>
			  <span slot="footer" class="dialog-footer">
			    <el-button @click="dialogVisible = false"  size="small">取 消</el-button>
			    <el-button type="primary" @click="deleteTerminal()"  size="small">确 定</el-button>
			  </span>
			</el-dialog>

			<!-- 分页 -->
			 <el-pagination
				class="paging"
				background
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page.sync="form.pageNo"
				:page-size="form.pageSize"
				layout="total, prev, pager, next"
				:pager-count="7"
				:total="form.totalCount">
			  </el-pagination>

		</div>
		<div :style="{height:tableHeight - 20 +'px'}" style="margin-right: 10px;">
			<el-table
			:maxHeight="tableHeight - 20 + 'px'"
		    ref="multipleTable"
			:data="form.terminalList"
			size="small"
			tooltip-effect="dark"
			border
			@selection-change="handleSelectionChange = arguments[0]">
			<el-table-column type="selection" width="40" align="center"></el-table-column>
			<el-table-column label="终端名称(devModel)">
				<template slot-scope="scope">
					<i class="el-icon-s-cooperation a"  @click="terminal(scope.row.id ,scope.row.name)" title="查看">{{ scope.row.name }}</i>
				</template>
			</el-table-column>
			<el-table-column label="类型">
				 <template scope="scope">
				  <div v-if="scope.row.type == submenu1.PHONE.code">手机</div>
				   <div v-else-if="scope.row.type == submenu1.PC.code">PC</div>
				   <div v-else-if="scope.row.type == submenu1.BOX.code">盒子</div>
				  <div v-else-if="scope.row.type == submenu1.OTHER.code">其他</div>
				</template>
			</el-table-column>
			<el-table-column prop="terminalDesc" label="描述"></el-table-column>
			<el-table-column prop="createDate" label="创建时间" width="120" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					{{formatCreateDate(scope.row.createDate)}}
				</template>
			</el-table-column>
			<el-table-column prop="updateDate" label="更新时间" width="120" align="center" show-overflow-tooltip>
				<template slot-scope="scope">
					{{formatCreateDate(scope.row.updateDate)}}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120" show-overflow-tooltip align="center">
				<template scope="scope">
				<el-button type="primary" size="small" @click="editproduct(scope.row)">编辑</el-button>
				</template>
				<!-- <el-button type="primary" size="small">查看</el-button> -->
			</el-table-column>
		</el-table>
		</div>

		<!-- 添加 编辑 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
			<el-form :model="form">
				<el-form-item label="终端名称" :label-width="formLabelWidth"  size="small"><el-input v-model="form.editlyAddedName" autocomplete="off"></el-input></el-form-item>

				<el-form-item label="类型" :label-width="formLabelWidth" size="small">
				<el-select v-model="form.type" placeholder="请选择类型" style="width: 100%;">
					<el-option
					  v-for="item in tableData"
					  :key="item.value"
					  :label="item.name"
					  :value="item.value">
					</el-option>
				  </el-select>
				 </el-form-item>

				 <el-form-item label="描述" :label-width="formLabelWidth">
				   <el-input type="textarea" v-model="form.terminalDesc"></el-input>
				 </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
				<el-button type="primary" @click="save_parameters()" size="small">确 定</el-button>
			</div>
		</el-dialog>

    <!-- 复制分组 -->

    <el-dialog title="复制终端" :visible.sync="dialogCopyProjectVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="copyForm">
        <el-form-item label="终端前缀:" :label-width="formLabelWidth"  size="small"><el-input v-model="copyForm.prefix" autocomplete="off"></el-input></el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelProjectGroup()" size="small">取 消</el-button>
        <el-button type="primary" @click="copyProject()" size="small">确 定</el-button>
      </div>
    </el-dialog>

	</div>
</template>

<script>
import constants from '@/js/constants.js'
  //添加一个的类型
  const submenu1 = constants.submenu1;
import api from '@/api/menu/'
import { mapState } from 'vuex';
  // 频道状态
 //  const submenu1 = {
 //    PHONE: { code: 1, label: '手机'},
 //    PC: { code: 2, label: 'pc' },
	// BOX: { code: 3, label: '盒子' },
	// OTHER: { code: 4, label: '其他' },
 //  };
export default {
	computed: {
		...mapState('main', ['tableHeight'])
	},
	data() {
		return {
			dialogVisible: false,
			tableData:constants.tableData,
      copyForm:{
        devProjectId: "",
        prefix: "",
        copyall: 2,
        ids: []
      },
      copyProjectData: [],
      dialogCopyProjectVisible: false,
			dialogFormVisible: false,
			handleSelectionChange:[],//获取删除的id和token
			dialogTitle:'',//添加 编辑
			submenu1,
			form: {
				val:"",
				type:'',
				productId:'',
				terminalList:[],
				terminalDesc:'',//描述
				editlyAddedName:'',
				pageSize:15,
				pageNo: 1,//当前页码
				//paginationShow: true,//是否显示分页
				totalCount: 0,//总条数
				querySertitleName:'',
				id:'',
				token:'',
				ids:[]
			},
			formLabelWidth: '120px',
		};
	},
	methods: {
		dialogVisible1(){
		   this.dialogVisible = true;
		   this.form.ids = this.handleSelectionChange.map(item => item.id);
		},
    copyProject(){
    this.saveCopyTerminal();
    },
    cancelProjectGroup(){
      this.dialogCopyProjectVisible= false;
    },
    saveCopyTerminal(){
      var data = {
        'copyall':this.copyForm.copyall,
        'prefix':this.copyForm.prefix,
        'token':this.form.token,
        'ids':this.copyForm.ids
      };
      var _this = this;

      api.copyTerminal(data)
        .then(res => {
          if(res.data.code == 0){
            this.dialogCopyProjectVisible= false;
            this.queryterminal();
            successMsg({
              message: '复制成功'
            })
          }else{
            errorMsg({
              message: res.data.msg
            })
          }
        })
    },
    handleCopyProjectSelect( val ) {
      if(val){
        this.copyForm.devProjectId = val.id;
      }
    },
    copyTerminal(){
      this.copyForm.devProjectId = '';
      this.copyForm.prefix = '';
      this.copyForm.ids = this.handleSelectionChange.map(item => item.id);
      if(this.copyForm.ids == 0) {
        errorMsg({
          message: "请选择终端"
        })
        return;
      }
		  this.copyForm.copyall = 1;
    this.dialogCopyProjectVisible= true;
    },
    copyAll(){
      this.copyForm.ids = [];
      this.copyForm.devProjectId = '';
      this.copyForm.prefix = '';
      this.copyForm.copyall = 2;
      this.dialogCopyProjectVisible= true;
    },
    queryproduct(){
      this.copyProjectData = [];
      var data = {
        'pageNo':1,
        'pageSize':10000,
        'token':this.form.token,
      };
      var _this = this;
      api.queryproduct(data)
        .then(res => {
          if(res.data.code == 0){
            this.copyProjectData = res.data.data.productList;
          }else{
            errorMsg({
              message: res.data.msg
            })
          }
        })
    },
		// 时间格式
		formatCreateDate: function(row) {
		  let createDate = row;
		  return window.formatDate(createDate);
		},
		//改变每页显示数量时调用
		  handleSizeChange(val) {
		  this.$nextTick(() =>
		    this.queryterminal(),
		  )
		},
		//点击下一页和点击页码时执行
		handleCurrentChange(val) {
		  this.queryterminal();
		},
		// 删除
		deleteTerminal(){
			this.dialogVisible = false;
			var ids = [];
			if(this.form.ids.length == 0){
			    ids = this.form.ids;
			}else{
				ids = this.form.ids;

			var data = {
			  'ids':this.form.ids,
			  'token':this.form.token
			};
		 api.delterminal(data)
			.then(res => {
				if(res.data.code == 0){
					if(this.form.ids.length == 0){
					}else{
						this.queryterminal();
						successMsg({
							   message: '删除成功'
						})
					}
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
			}
		},
		// 保存
		save_parameters(){

			var id = '';
			if(this.form.id){
				id = this.form.id;
			}else{
				id = '';
			}
			 var data = {
			  'id':id,
			  'terminalDesc':this.form.terminalDesc,
			  'type':parseInt(this.form.type),
			  'name':this.form.editlyAddedName,
			  'token':this.form.token
			};

		 api.editterminal(data)
			.then(res => {
				if(res.data.code == 0){
					this.form.type = "";
					this.form.editlyAddedName = '';
					this.queryterminal();
					this.form.terminalDesc = '';
					this.form.id = '';
					console.log(res.data.msg);
					successMsg({
						   message: '保存成功'
					})
					this.dialogFormVisible = false;
				}else{
				   errorMsg({
				   	   message: res.data.msg
				   })
				   this.dialogFormVisible = true;
				}
			})
		},
		// url传参数
		terminal(id ,val) {
			this.$router.push({
				path: '/Terminal',
        name: 'Terminal',
        params:{
				  tid:id,
				  Tval:val
				}
			});
		},


	// 11.6 查询终端
		queryterminal(){
			this.form.terminalList = [];
			var data = {
			  'productId':this.form.productId,
			  'pageNo':this.form.pageNo,
			  'pageSize':this.form.pageSize,
			  'type':this.form.type,
			  'name':this.form.querySertitleName,
			  'token':this.form.token,
			  'terminalDesc':this.form.terminalDesc,
			};
			var _this = this;
		 api.queryterminal(data)
			.then(res => {
				if(res.data.code == 0){
					this.form.terminalList = res.data.data.terminalList;
					this.form.totalCount = res.data.data.totalSize;
				}else{
					errorMsg({
						   message: res.data.msg
					})
				}
			})
		},

		// 添加 编辑
		editproduct(parameter){
				if(parameter){
				this.dialogTitle = "编辑终端";
				this.dialogFormVisible = true;
				this.form.terminalDesc = parameter.terminalDesc;
				this.form.editlyAddedName = parameter.name;
				this.form.productId = parameter.productId;
				this.form.id = parameter.id;
				this.form.type = parameter.type;
				// this.form.token = parameter.token;
				}else{
					// 添加
					this.dialogTitle = "添加终端"
					this.dialogFormVisible = true;
					this.form.type = this.tableData[0].value;
					this.form.editlyAddedName = '';
					this.form.terminalDesc = '';
					this.form.id = '';
				}
		},
	},
	  created() {
		  // this.form.productId = this.$route.params.id;
		  // this.form.val = this.$route.params.val;
      // this.form.token = this.$cookies.get('USER_TOKEN_COOKIE');
      this.queryterminal();
      //this.queryproduct();
	  },
};
</script>
<style scoped lang="less">
.meun {
	.crumbs{
		margin-top: 10px;
	}
	.header {
		position: relative;
		height: 60px;
		line-height: 60px;
        .paging{
			position: absolute;
			right: 0px;
			top: 10px;
		}
		.search {
			width: 200px;
		}
	}
	.a {
		cursor: pointer;
	}
}
.greenrecord{
  color: #00FF00;
}
</style>
